module.exports = __webpack_public_path__ + "img/new-domain-same-dripify.467f8c88.svg";